import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function CardIcon(_a) {
    var desktopIcon = _a.desktopIcon, mobileIcon = _a.mobileIcon;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "hidden mdl:block p-[1.125rem] rounded-full bg-secondary-light", children: desktopIcon }), _jsx("div", { className: "block mdl:hidden p-[0.5rem] rounded-full bg-secondary-light", children: mobileIcon })] }));
}
